import PreorderSplitShippingMinimumsPage from "@faire/prototype-playground/workspace/remy/preorder-split-shipping-minimums";
import { Route, Switch } from "react-router-dom";

export function RemyGordonRoutes() {
  return (
    <Switch>
      <Route
        path="/remy/preorder-split-shipping-minimums"
        component={PreorderSplitShippingMinimumsPage}
      />
    </Switch>
  );
}

export const slug = "remy";
